import React from 'react'
import './style.scss'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()

function urlFormatting (companyWebsiteUrl) {
  let urls = {display: '', link: ''}
  if (companyWebsiteUrl.indexOf('https://') === 0 || companyWebsiteUrl.indexOf('http://') === 0) {
    urls.display = companyWebsiteUrl.split('//').pop()
    urls.link = companyWebsiteUrl
  } else {
    urls.display = companyWebsiteUrl
    urls.link = 'http://' + companyWebsiteUrl
  }
  return urls
}

const TerciaryHorizontalCard = ({data, closeMobileMenu}) => {
  const {companyDescription, companyName, companySideList1, companyWebsiteUrl} = data
  const description = md.render(companyDescription.companyDescription)
  let arrayOfLists
  let listsGrid = 'grid-1of2'
  const urls = urlFormatting(companyWebsiteUrl)

  if (companySideList1) {
    let sideList = companySideList1.split(';')
    arrayOfLists = []
    sideList.forEach((list) => {
      let singleList = list.split(':')
      let title = singleList[0]
      let listItems = singleList[1].split(',')
      arrayOfLists.push({title, listItems})
    })

    if (arrayOfLists.length === 1) {
      listsGrid = 'grid-1of1'
    }
  }

  return (
    <div className='terciaryHorizontalCard-wrapper'>
      <div className='container container--narrow u-relative'>
        <div className='terciaryHorizontalCard-closeMenu' onClick={() => closeMobileMenu()} />
        <div className='grid'>
          <div className='grid-1of2 grid-1of1--phablet u-alignCenter--phablet u-marginTopMedium--phablet'>
            <div className='u-marginBottomXsmall'>
              <span className='terciaryHorizontalCard-title'>{companyName}</span>
              <a href={urls.link} className='terciaryHorizontalCard-link' target='_blank'>{urls.display}</a>
            </div>
            <div className='terciaryHorizontalCard-contentWrapper' dangerouslySetInnerHTML={{__html: description}} />
          </div>
          {companySideList1 ? <div className={`grid-1of2 grid-1of1--phablet`} >
            <div className='grid'>
              {arrayOfLists.map(function (list, index) {
                return (
                  <div className={`${listsGrid} grid-1of1--ipad u-marginBottomSmall--ipad u-marginBottomMedium--phablet u-alignCenter--phablet`} key={index}>
                    <span className='terciaryHorizontalCard-listTitle'>{list.title}</span>
                    <ul>
                      {list.listItems.map(function (item, i) {
                        return <li className='terciaryHorizontalCard-listItem' key={i}>{item}</li>
                      })}
                    </ul>
                  </div>
                )
              })}
            </div>
          </div> : ''}
        </div>
      </div>
    </div>
  )
}

export default TerciaryHorizontalCard



// WEBPACK FOOTER //
// ./src/components/terciary-horizontal-card/index.js